import React from "react";
import productDashboardStyle from "./productsDashboardStyle";
import { Box, Divider, List, ListItemButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import divorceIcon from "../../assets/icon/product/icon_scheidung.svg";
import trafficIcon from "../../assets/icon/product/icon_verkehrsrecht.svg";
import trafficAccidentIcon from "../../assets/icon/product/icon_verkehrsunfall.svg";
import settlementIcon from "../../assets/icon/product/icon_arbeitsrecht.svg";
import employmentContractIcon from "../../assets/icon/product/icon_arbeitsvertrag.svg";
import documentsIcon from "../../assets/icon/product/icon_dokumente.svg";
import familyLawIcon from "../../assets/icon/product/icon_familienrecht.svg";
import contractLawIcon from "../../assets/icon/product/icon_vertragsrecht.svg";
import dataLeakContractIcon from "../../assets/icon/product/icon_datenweitergabe.svg";
import tenancyLawIcon from "../../assets/icon/product/icon_mietvertrag.svg";
import generalCivilLawIcon from "../../assets/icon/product/icon_allgemeines_zivilrecht.svg";
import civilServiceLawIcon from "../../assets/icon/product/icon_beamtenrecht.svg";
import ContentBox from "../ContentBox/ContentBox";
import { translate } from "../../services/Translations/translatorService";

const ProductsDashboard = ({}) => {
  return (
    <Box sx={{ maxWidth: 360, margin: "auto" }}>
      <ContentBox padding="none">
        <List>
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/scheidung/offen"}
          >
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box component={"img"} src={divorceIcon} sx={productDashboardStyle.icon} alt={"Scheidung"} />
              </Grid>
              <Grid>{translate("divorce.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/arbeitsvertrag/offen"}
          >
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box
                  component={"img"}
                  src={employmentContractIcon}
                  sx={productDashboardStyle.icon}
                  alt={translate("employmentContract.label")}
                />
              </Grid>
              <Grid>{translate("employmentContract.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/abfindung/offen"}
          >
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box component={"img"} src={settlementIcon} sx={productDashboardStyle.icon} alt={"Abfindung"} />
              </Grid>
              <Grid>{translate("settlement.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton sx={productDashboardStyle.productItem} component={Link} to={"/services/board/verkehr/offen"}>
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box component={"img"} src={trafficIcon} sx={productDashboardStyle.icon} alt={"Verkehr"} />
              </Grid>
              <Grid>{translate("traffic.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/verkehrsunfall/offen"}
          >
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box
                  component={"img"}
                  src={trafficAccidentIcon}
                  sx={productDashboardStyle.icon}
                  alt={"Verkehrsunfall"}
                />
              </Grid>
              <Grid>{translate("trafficAccident.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/dokumente/offen"}
          >
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box component={"img"} src={documentsIcon} sx={productDashboardStyle.icon} alt={"Dokumente"} />
              </Grid>
              <Grid>Dokumente</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton sx={productDashboardStyle.productItem} component={Link} to={"/services/board/familie/offen"}>
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box component={"img"} src={familyLawIcon} sx={productDashboardStyle.icon} alt={"Familienrecht"} />
              </Grid>
              <Grid>{translate("familyLawCase.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/vertragsrecht/offen"}
          >
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box
                  component={"img"}
                  src={contractLawIcon}
                  sx={productDashboardStyle.icon}
                  alt={translate("general.productCategory.contractLaw")}
                />
              </Grid>
              <Grid>{translate("general.productCategory.contractLaw")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/datenweitergabe/offen"}
          >
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box
                  component={"img"}
                  src={dataLeakContractIcon}
                  sx={productDashboardStyle.icon}
                  alt={translate("dataLeakContract.label")}
                />
              </Grid>
              <Grid>{translate("dataLeakContract.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/mietrecht/offen"}
          >
            <Grid container spacing={3} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box
                  component={"img"}
                  src={tenancyLawIcon}
                  sx={productDashboardStyle.icon}
                  alt={translate("rentalContract.label")}
                />
              </Grid>
              <Grid>{translate("rentalContract.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/allgemeines-zivilrecht/offen"}
          >
            <Grid container spacing={3} wrap={"nowrap"} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box
                  component={"img"}
                  src={generalCivilLawIcon}
                  sx={productDashboardStyle.icon}
                  alt={translate("generalCivilLaw.label")}
                />
              </Grid>
              <Grid>{translate("generalCivilLaw.label")}</Grid>
            </Grid>
          </ListItemButton>
          <Divider />
          <ListItemButton
            sx={productDashboardStyle.productItem}
            component={Link}
            to={"/services/board/beamtenrecht/offen"}
          >
            <Grid container spacing={3} wrap={"nowrap"} sx={{
              alignItems: "center"
            }}>
              <Grid>
                <Box
                  component={"img"}
                  src={civilServiceLawIcon}
                  sx={productDashboardStyle.icon}
                  alt={translate("civilServiceLaw.label")}
                />
              </Grid>
              <Grid>{translate("civilServiceLaw.label")}</Grid>
            </Grid>
          </ListItemButton>
        </List>
      </ContentBox>
    </Box>
  );
};

export default ProductsDashboard;
